import Vue from 'vue'
import Vuex from 'vuex'
import * as job from '@/store/modules/job.js'
import * as post from '@/store/modules/post.js'
import * as notification from '@/store/modules/notification.js'
import * as auth from '@/store/modules/auth.js'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		job,
		notification,
		auth,
		post
	},
	state: {},
	mutations: {},
	actions: {},
	getters: {}
})
